<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel">
                        <h2>{{tituloDaEtapaAtual}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <div class="form-group">
                    <mat-divider fxFlex="1 0"></mat-divider>
                </div>
                <div class="panel-heading custom-sub-panel">
                    <div class="titulo-sub-painel">
                        <h3 class="form-dados-marcacao-consulta-msg-sucesso">A consulta abaixo foi marcada com
                            sucesso.
                            Aguarde a impressão do seu comprovante.</h3>
                    </div>
                </div>

                <div class="form-row" class="form-row form-dados-marcacao-consulta">
                    <div class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                        <label for="marcacaoConsulta" class="label-titulo">Consulta</label>
                        <br />
                        <label id="marcacaoConsulta">{{marcacaoConsulta.procedimentoConsulta.nome}}</label>
                    </div>
                    <div class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                        <label for="dataMarcacao" class="label-titulo">Data / Hora</label>
                        <br />
                        <label id="dataMarcacao">
                            {{ marcacaoConsulta.pk.dataMarcacaoConsulta | date:"dd/MM/yyyy" }}
                            {{ marcacaoConsulta.horaAtendimento | horaFormatadaPipe }}
                        </label>
                    </div>
                    <div class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                        <label for="medico" class="label-titulo">Médico</label>
                        <br />
                        <label id="medico">{{marcacaoConsulta.nomeMedico}}</label>
                    </div>
                    <div class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                        <label for="valor" class="label-titulo">Valor</label>
                        <br />
                        <label id="valor">{{this.marcacaoConsulta | moedaFormatadaPipe}}</label>
                    </div>
                    <!-- <div class="form-group col-md-4">
                        <label for="observacao" class="label-titulo">Observação</label>
                        <br />
                        <label id="observacao">Todos atendimentos são por ordem de chegada.</label>
                    </div> -->
                    <div class="form-group col-md-12">
                        <label class="label-titulo-atencao">
                            Atenção: Caso o comprovante não apareça na tela verifique as configurações de popup do seu
                            navegador.
                        </label>
                    </div>
                </div>
                <div class="form-row" class="form-row form-botoes-marcacao-realizada">
                    <div class="form-group col-lg-4 col-md-12">
                        <button type="button" mat-button (click)="imprimirComprovante()">
                            <mat-icon>picture_as_pdf</mat-icon>
                            Imprimir comprovante
                        </button>
                    </div>
                    <div class="form-group col-lg-4 col-md-12">
                        <button type="button" mat-button (click)="enviarComprovantePorEmail()">
                            <mat-icon>email</mat-icon>
                            Enviar comprovante por e-mail
                        </button>
                    </div>
                    <div class="form-group col-lg-4 col-md-12">
                        <button type="button" mat-button (click)="enviarComprovantePorSMS()"
                            disabled="{{marcacaoConsulta.comprovanteSMSEnviado}}">
                            <mat-icon>phone_android</mat-icon>
                            Enviar comprovante para o celular
                        </button>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group botao-marcacao-esquerda col-12 col-sm-6 col-md-6 col-lg-6">
                        <button type="button" (click)="telaAnterior()" mat-raised-button color="primary"
                            matTooltip="Tela Anterior" style="margin-bottom: 10px;">Tela Inicial</button>
                    </div>
                    <div class="form-group botao-marcacao-direita col-12 col-sm-6 col-md-6 col-lg-6">
                        <button type="button" (click)="proximaTela()" mat-raised-button color="primary"
                            matTooltip="Continuar Marcação">Nova Marcação</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>